export const DEBOUNCE_TYPING_TIMEOUT = 1_000;
